import type { HTMLProps } from 'react';

import type { DaDataFioSuggestion } from '@pulse-web-ui/dadata';

export enum FilterParts {
  NAME = 'NAME',
  PATRONYMIC = 'PATRONYMIC',
  SURNAME = 'SURNAME',
}

export type DadataInputProps = HTMLProps<HTMLInputElement> & {
  error?: boolean;
};

export type DadataFioSuggestionsProps = {
  onChange: (value: undefined | DaDataFioSuggestion) => void;
  value?: DaDataFioSuggestion;
  defaultQuery?: string;
  filterParts?: FilterParts[];
  delay?: number;
  minChars?: number;
  uid?: string;
  inputProps?: DadataInputProps;
  error?: boolean;
};
